import { Box, type Theme, styled, useMediaQuery } from "@mui/material";
import * as React from "react";
import { FilterLiveForm, type ListProps, InfiniteList as RaList } from "react-admin";
import { ListStyle } from "./List";
import { FilterAside } from "./filter-aside";

interface FilterListProps extends ListProps {
    top?: React.ReactElement;
    open: boolean;
    onOpen: (open: boolean) => void;
}

const Form = styled("form")({ width: "100%" });

export const InfiniteList = ({ children, top, aside, open, onOpen, ...rest }: FilterListProps): JSX.Element => {
    const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("lg"));
    return (
        <Box sx={{ display: "flex", paddingTop: 0.5 }}>
            {/* @ts-expect-error asd */}
            <StyledList
                {...rest}
                actions={<FilterLiveForm formComponent={Form}>{top}</FilterLiveForm>}
                open={open}
                isSmall={isSmall}
                aside={
                    <FilterAside open={open} onOpen={onOpen} isSmall={isSmall}>
                        {React.Children.map(aside, child => (React.isValidElement(child) ? React.cloneElement(child, { open } as any) : child)) as any}
                    </FilterAside>
                }
                disableSyncWithLocation
                debounce={0}
                empty={false}
                sx={{ paddingTop: 0 }}
            >
                {children}
            </StyledList>
        </Box>
    );
};

const StyledList = styled(RaList, { shouldForwardProp: prop => prop !== "open" })(ListStyle);
